import { render, staticRenderFns } from "./ReceivedLogBox.vue?vue&type=template&id=64f318d7&"
import script from "./ReceivedLogBox.vue?vue&type=script&lang=js&"
export * from "./ReceivedLogBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports